import React from 'react'
import ReactDOM from 'react-dom/client'
import App from './App'
import { BrowserRouter } from 'react-router-dom'
import { ThemeProvider } from './components/chakraComponents/theme-provider'
import './components/chakraComponents/fonts'
import { AppConfigProvider, Auth0ProviderWithNavigate, AuthenticationGuard, EnvConfigProvider } from 'rwo-react'
import { QueryClient, QueryClientProvider } from '@tanstack/react-query'
import { LoadingPage } from './pages/LoadingPage'

const client = new QueryClient();
const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement)
root.render(
  <ThemeProvider defaultTheme='light'>
    <React.StrictMode>
      <EnvConfigProvider devUri="http://localhost:3000" config={process.env as Record<string, string>}>
        <QueryClientProvider client={client}>
          <BrowserRouter>
            <Auth0ProviderWithNavigate>
              <AuthenticationGuard loadingPage={<LoadingPage />}>
                <AppConfigProvider>
                  <App />
                </AppConfigProvider>
              </AuthenticationGuard>
            </Auth0ProviderWithNavigate>
          </BrowserRouter>
        </QueryClientProvider>
      </EnvConfigProvider>
    </React.StrictMode>
  </ThemeProvider>
)
